import { createRedirectSession as publicCreateRedirectSession } from './headless-v1-redirect-session-redirects.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onRedirectSessionCreated as publicOnRedirectSessionCreated } from './headless-v1-redirect-session-redirects.public.js';

export const createRedirectSession: MaybeContext<
  BuildRESTFunction<typeof publicCreateRedirectSession> &
    typeof publicCreateRedirectSession
> = /*#__PURE__*/ createRESTModule(publicCreateRedirectSession);
/**
 * Triggered when a redirect session is created.
 */
export const onRedirectSessionCreated: BuildEventDefinition<
  typeof publicOnRedirectSessionCreated
> &
  typeof publicOnRedirectSessionCreated = createEventModule(
  publicOnRedirectSessionCreated
);

export {
  LocationType,
  Prompt,
  MembersAccountSection,
  AttachPagesResponseStatus,
  CallbackType,
  Status,
  WebhookIdentityType,
} from './headless-v1-redirect-session-redirects.universal.js';
export {
  RedirectSession,
  URLDetails,
  CreateRedirectSessionRequest,
  CreateRedirectSessionRequestIntentOneOf,
  RedirectSessionBookingsCheckoutParams,
  SlotAvailability,
  Slot,
  SlotResource,
  Location,
  PhoneCall,
  WaitingList,
  BookingPolicyViolations,
  NestedTimeSlot,
  RedirectSessionEcomCheckoutParams,
  RedirectSessionEventsCheckoutParams,
  RedirectSessionPaidPlansCheckoutParams,
  RedirectSessionLoginParams,
  RedirectSessionLogoutParams,
  RedirectSessionAuthParams,
  AuthorizeRequest,
  RedirectSessionMembersAccountParams,
  RedirectSessionStoresProductParams,
  RedirectSessionBookingsBookParams,
  CallbackParams,
  RedirectSessionPreferences,
  CustomMemberPaths,
  CreateRedirectSessionResponse,
  CreateAnonymousRedirectSessionRequest,
  CreateAnonymousRedirectSessionRequestIntentOneOf,
  CreateAnonymousRedirectSessionResponse,
  AttachPagesRequest,
  AttachPagesResponse,
  ValidateCallbackURLRequest,
  ValidateCallbackURLResponse,
  SignInURLRequest,
  SignInURLResponse,
  AttachAllTemplatesRequest,
  AttachAllTemplatesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  RedirectSessionCreatedEnvelope,
  CreateRedirectSessionOptions,
  CreateRedirectSessionOptionsIntentOneOf,
} from './headless-v1-redirect-session-redirects.universal.js';
export {
  LocationTypeWithLiterals,
  PromptWithLiterals,
  MembersAccountSectionWithLiterals,
  AttachPagesResponseStatusWithLiterals,
  CallbackTypeWithLiterals,
  StatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './headless-v1-redirect-session-redirects.universal.js';
